import { render, staticRenderFns } from "./SharedDocumentListScreen.vue?vue&type=template&id=2b497170&scoped=true&"
import script from "./SharedDocumentListScreen.vue?vue&type=script&lang=js&"
export * from "./SharedDocumentListScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b497170",
  null
  
)

export default component.exports